import axios from "axios"
import { baseURL, config, requestID } from "../../common/utils"

export const getFilterApplicants = async (data) => {

    const payload = {
        requestID: requestID(), ...data
    }

    try {
        const res = axios.post(`${baseURL}jobs/filterApplications`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}

export const processPayrollData = async (data) => {

    const payload = {
        requestID: requestID(), ...data
    }

    try {
        const res = axios.post(`${baseURL}payrolls/upload`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}
export const getJobsQuestion = async (data) => {

    const payload = {
        requestID: requestID(), ...data
    }

    try {
        const res = axios.post(`${baseURL}jobs/getJobQuestions`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}
export const getPayrollItems = async (data) => {

    const payload = {
        requestID: requestID(), ...data
    }

    try {
        const res = axios.post(`${baseURL}payrolls/getPayrollItems`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}
export const addPayrollItem = async (data) => {

    const payload = {
        requestID: requestID(), ...data
    }

    try {
        const res = axios.post(`${baseURL}payrolls/addPayrollItem`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}


export const updatePayrollItem = async (data) => {

    const payload = {
        requestID: requestID(), ...data
    }

    try {
        const res = axios.post(`${baseURL}payrolls/updatePayrollItem`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}
export const handleDeletePayrollItem = async (data) => {

    const payload = {
        requestID: requestID(), ...data
    }

    try {
        const res = axios.post(`${baseURL}payrolls/updatePayrollItem`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}
export const addSalaryScales = async (data) => {

    const payload = {
        requestID: requestID(), ...data
    }

    try {
        const res = axios.post(`${baseURL}payrolls/addSalaryScales`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}
export const getSalaryScalesByBranch = async (data) => {

    const payload = {
        requestID: requestID(), ...data
    }

    try {
        const res = axios.post(`${baseURL}payrolls/getSalaryScalesByBranch`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}
export const getPayrollData = async (data) => {

    const payload = {
        requestID: requestID(), ...data
    }

    try {
        const res = axios.post(`${baseURL}payrolls/getPayrollData`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}

export const generateEmployeePayroll = async (data) => {

    const payload = {
        requestID: requestID(), ...data
    }

    try {
        const res = axios.post(`${baseURL}payrolls/generateEmployeePayroll`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}


export const savePayrollData = async (data) => {

    const payload = {
        requestID: requestID(), ...data
    }

    try {
        const res = axios.post(`${baseURL}payrolls/savePayrollData`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}
export const uploadAllowancesAndDedcution = async (formData, onUploadProgress) => {

    try {
        const res = axios.post(`${baseURL}payrolls/uploadAllowancesAndDeduction`, formData, { onUploadProgress, ...config })
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}